import { request, requestFile } from '../@utils'
const stockOutService = {
  baseQueryPath: '/inventory/stock-out/',
  getStockList: params => {
    return request.post('inventory/stock-out/list', { data: params })
  },
  getStockProductList: params => {
    return request.post('inventory/stock-out/detail-product', { data: params })
  },
  discardStockSheet: no => {
    return request.post(`inventory/stock-out/discard/${no}`)
  },
  exportStockSheet: params => {
    return requestFile.post(`inventory/stock-out/export`, {
      data: params,
      responseType: 'blob'
    })
  },
  getStockDetail: no => {
    return request.get(`inventory/stock-out/detail/${no}`)
  }
}
export default stockOutService
